"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitFeeTierConfigTx = exports.getInitWhirlpoolConfigsTx = void 0;
const whirlpool_client_sdk_1 = require("@orca-so/whirlpool-client-sdk");
const address_1 = require("../../utils/address");
function getInitWhirlpoolConfigsTx({ programId, provider, whirlpoolConfigKeypair, feeAuthority, collectProtocolFeesAuthority, rewardEmissionsSuperAuthority, defaultProtocolFeeRate, }) {
    const ctx = whirlpool_client_sdk_1.WhirlpoolContext.withProvider(provider, (0, address_1.toPubKey)(programId));
    const client = new whirlpool_client_sdk_1.WhirlpoolClient(ctx);
    return client.initConfigTx({
        whirlpoolConfigKeypair,
        feeAuthority: (0, address_1.toPubKey)(feeAuthority),
        collectProtocolFeesAuthority: (0, address_1.toPubKey)(collectProtocolFeesAuthority),
        rewardEmissionsSuperAuthority: (0, address_1.toPubKey)(rewardEmissionsSuperAuthority),
        defaultProtocolFeeRate,
        funder: provider.wallet.publicKey,
    });
}
exports.getInitWhirlpoolConfigsTx = getInitWhirlpoolConfigsTx;
function getInitFeeTierConfigTx({ programId, provider, whirlpoolConfigKey, feeAuthority, tickSpacing, defaultFeeRate, }) {
    const ctx = whirlpool_client_sdk_1.WhirlpoolContext.withProvider(provider, (0, address_1.toPubKey)(programId));
    const client = new whirlpool_client_sdk_1.WhirlpoolClient(ctx);
    const feeTierPda = (0, whirlpool_client_sdk_1.getFeeTierPda)((0, address_1.toPubKey)(programId), (0, address_1.toPubKey)(whirlpoolConfigKey), tickSpacing);
    const params = {
        whirlpoolConfigKey: (0, address_1.toPubKey)(whirlpoolConfigKey),
        feeAuthority: (0, address_1.toPubKey)(feeAuthority),
        feeTierPda,
        tickSpacing,
        defaultFeeRate,
        funder: provider.wallet.publicKey,
    };
    return client.initFeeTierTx(params);
}
exports.getInitFeeTierConfigTx = getInitFeeTierConfigTx;
